export default __webpack_public_path__ + "static/media/close-icon-dark.8e4de1c3.svg";